module.exports = __webpack_public_path__ + "93699f8b1a633205f93a6f6a77aac790.fbx";